import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { APIServices } from '../config/app-config';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppService } from '../modules/shared/app-service/app-service.service';


@Injectable()
export class PermissAccessPage implements CanActivate {

  constructor(private router: Router, private http: HttpClient, public appService: AppService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    //Params
    let query = `?Ruta=${route.routeConfig.path}`;
    //Url
    let url = APIServices.common.getPermissionForPage + query;

    let promise = new Promise<boolean>((resolve, reject) => {
      if (!this.appService.isLogged) {
        resolve(true);
      } else {

        this.http.get(url)
          .toPromise()
          .then(result => {
            if (result) {
              resolve(true);
            } else {
              // TODO by default now go to config, last go to home
              this.router.navigate(['/config']);
              //this.router.navigate(['/home']);
              this.appService.setLoadingFalse();
              resolve(false);
            }
          })
          .catch(error => {
            reject(false);
          })
      }
    });

    return promise;

  }

}
